// Purpose: Load and disconnect Integration Engine accounts through trusted
// callable Functions without granting browsers access to credential documents.
// Features: Normalizes the server response into the existing provider-keyed UI
// model and centralizes the disconnect mutation.
// Dependencies: Firebase callable Functions and the configured LGV Functions
// client. Important behavior: returned records contain metadata only; provider
// tokens must never be returned or logged.

import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const getIntegrationConnectionMap = async (eventId) => {
  const response = await httpsCallable(
    functions,
    "getIntegrationConnections"
  )({eventId});
  const connections = Array.isArray(response.data?.connections)
    ? response.data.connections
    : [];

  return connections.reduce((result, connection) => {
    const key = String(connection?.id || connection?.platform || "").trim();
    if (key) result[key] = connection;
    return result;
  }, {});
};

export const disconnectIntegration = async ({eventId, platform}) => {
  const response = await httpsCallable(
    functions,
    "disconnectIntegrationConnection"
  )({eventId, platform});

  return response.data;
};
